import { Device } from '@cardsjd/device';
import { BasePortal } from './BasePortal.js';
import { CrazyGamesPortal } from './CrazyGamesPortal.js';
import { FacebookPortal } from './FacebookPortal.js';
import { WebPortal } from './WebPortal.js';
//import { GameDistributionPortal } from './GameDistributionPortal';
//import { DiscordPortal } from './DiscordPortal';

const PortalLoaders = {
	crazygames: CrazyGamesPortal,
	facebook: FacebookPortal,
	web: WebPortal,
	windowsPWA: WebPortal,
	windows: WebPortal,
	//gamedistribution: GameDistributionPortal,
	//discord: DiscordPortal,
};


//Factory class for creating platform-specific portal instances.
export class Portal {
	/**
	 * Creates and initializes a portal instance based on the current platform.
	 * @param {Object} appConfig - Configuration object to pass to the portal
	 * @param {Object} advertisementConfig - Configuration object to pass to the portal
	 * @returns {BasePortal} The initialized portal instance
	 */
	static create(platform, appConfig, advertisementConfig) {

		if (!platform) {
			const device = new Device();
			platform = device.getPlatform();
		}

		const portalClass = PortalLoaders[platform];
		const portal = portalClass ? new portalClass(appConfig, advertisementConfig) : new BasePortal(appConfig, advertisementConfig);

		return portal;
	}
}
